import React from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { Carousel } from 'react-responsive-carousel';

import carousel1ipad from '../../../assets/images/carousel1ipad.png';
import carousel2headset from '../../../assets/images/carousel2headset.png';
// import OurMembers from './OurMembers';


const WhoWeAre = ({ isMobile }) => {

  return (
    <Col>
      <Row>
        <Col>
          <h2
            id="who-we-are"
            tabIndex="-1"
          >
            WHO WE ARE
          </h2>
        </Col>
      </Row>
      <Row
        style={{
          marginTop: 120,
          paddingRight: isMobile ? 0 : 60,
          paddingLeft: isMobile ? 0 : 60
          // border: '6px solid pink' 
        }}
      >
        <div style={{ width: '100%' }}>


          <Carousel
            showIndicators={false}
            showStatus={false}
            showArrows={true}
            showThumbs={false}
            swipeable
            emulateTouch
            autoPlay={false}
            interval={9999999}
            preventMovementUntilSwipeScrollTolerance
            infiniteLoop
          // onChange={onChange} onClickItem={onClickItem} onClickThumb={onClickThumb}
          >

            <OurMission />

            <OurVision />

            <OurValues />

          </Carousel>
        </div>
      </Row>
    </Col>
  )

}

export default WhoWeAre;

const OurMission = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 120
  }}>
    <Container
      // className="legend"
      style={{
        display: 'flex',
        flexDirection: 'row',
        maxWidth: 880,
        marginRight: 80,
        marginLeft: 80,
        height: 200
      }}>
      <Row>
        <Col xs={12} sm={12} md={4}>
          <img
            src={carousel1ipad}
            style={{
              height: 'auto',
              width: '100%',
              maxWidth: 320,
              marginBottom: 30
            }}
            aria-label="Picture of someone using an iPad"
          />
        </Col>
        <Col xs={12} sm={12} md={7}>
          <h3 style={{
            textAlign: 'left',
          }}>
            OUR MISSION
          </h3>
          <div
            className="whoWeAreDetails"
            style={{
              textAlign: 'left',
              marginTop: 20
            }}>
            CSIO's mission is to <strong>deliver leading-edge technology Standards and solutions</strong> in order to <strong>continuously improve the consumer's ease of doing business</strong> within the broker channel.
          </div>
        </Col>
      </Row>
    </Container>
  </div >
);

const OurVision = () => (
  (
    <div style={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 120
    }}>
      <Container
        // className="legend"
        style={{
          display: 'flex',
          flexDirection: 'row',
          maxWidth: 880,
          marginRight: 80,
          marginLeft: 80,
          height: 200
        }}>
        <Row>
          <Col xs={12} sm={12} md={4}>
            <img
              src={carousel2headset}
              style={{
                height: 'auto',
                width: '100%',
                maxWidth: 320,
                marginBottom: 30
              }}
              aria-label="Picture of someone using an iPad"
            />
          </Col>
          <Col xs={12} sm={12} md={7}>
            <h3 style={{
              textAlign: 'left',
            }}>
              OUR VISION
            </h3>
            <div
              className="whoWeAreDetails"
              style={{
                textAlign: 'left',
                marginTop: 20
              }}>
                  CSIO is a highly respected organization that delivers <strong>leading-edge technology Standards and solutions</strong> enabling <strong>excellent customer experience</strong> through the broker channel.
            </div>
          </Col>
        </Row>
      </Container>
    </div >
  )
);

const OurValues = () => (
  <div style={{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    // alignItems: 'center',
    // marginBottom: 120
  }}>
    <div
      // className="legend"
      style={{
        // display: 'flex',
        // flexDirection: 'row',
        maxWidth: 880,
        // marginRight: 80,
        // marginLeft: 80
        // height: 200
      }}>

      <Container>
        <Row>
          <Col>
            <h3 style={{ textAlign: 'left' }}>OUR VALUES</h3>
            <ul style={{ listStyleType: 'none', textAlign: 'left', marginTop: 20, paddingLeft: 0 }}>
              <li style={{ marginBottom: 20 }}>
                <span className="carouselValueTitle">> Collaborative: </span>
                <span className="carouselValueText">Working together toward our common interests while recognizing the competitive nature of the industry.</span>
              </li>
              <li style={{ marginBottom: 20 }}>
                <span className="carouselValueTitle">> Proactive: </span>
                <span className="carouselValueText">Recognizing industry challenges and influencing them within our scope.</span>
              </li>
            </ul>
            {/* </Col>
          <Col> */}
            <ul style={{ listStyleType: 'none', textAlign: 'left', marginTop: 20, paddingLeft: 0 }}>
              <li style={{ marginBottom: 20 }}>
                <span className="carouselValueTitle">> Responsive: </span>
                <span className="carouselValueText">Delivering timely, relevant solutions.</span>
              </li>
              <li style={{ marginBottom: 20 }}>
                <span className="carouselValueTitle">> Disciplined: </span>
                <span className="carouselValueText">Applying good governance at all levels of the organization, resulting in focused execution.</span>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  </div>
);


//  @ADVISE
// const OurMembers = () => (
//   <div style={{
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'center',
//     // alignItems: 'center',
//     marginBottom: 120
//   }}>
//     <div
//       // className="legend"
//       style={{
//         // display: 'flex',
//         // flexDirection: 'row',
//         maxWidth: 880,
//         marginRight: 80,
//         marginLeft: 80
//         // height: 200
//       }}>
//       <h3 style={{ textAlign: 'center' }}>OUR MEMBERS</h3>
//       <ul style={{ listStyleType: 'none', textAlign: 'left', marginTop: 20 }}>
//         <li style={{ marginBottom: 20, marginRight: 40 }}>
//               <Odom
//                 number={80}
//                 text="+ INSURERS"
//                 style={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
//                 textStyle={{
//                   marginTop: 14,
//                   fontSize: 32,
//                   fontFamily: 'montserrat bold',
//                   fontWeight: 'bold',
//                   color: '#48604C',

//                 }}
//                 odomStyle={{
//                   fontSize: 32,
//                   fontFamily: 'montserrat bold',
//                   fontWeight: 'bold',
//                   color: '#48604C',
//                   marginBottom: 4
//                   // padding: 0,
//                 }} />
//         </li>
//         <li style={{ marginBottom: 20, marginRight: 40 }}>
//               <Odom
//                 number={35}
//                 text="+ VENDORS"
//                 style={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
//                 textStyle={{
//                   marginTop: 14,
//                   fontSize: 32,
//                   fontFamily: 'montserrat bold',
//                   fontWeight: 'bold',
//                   color: '#48604C',

//                 }}
//                 odomStyle={{
//                   fontSize: 32,
//                   fontFamily: 'montserrat bold',
//                   fontWeight: 'bold',
//                   color: '#48604C',
//                   marginBottom: 4
//                   // padding: 0,
//                 }} />
//         </li>
//         <li style={{ marginBottom: 20, marginRight: 40 }}>
//               <Odom
//                 number={38}
//                 text="K+ BROKERS"
//                 style={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
//                 textStyle={{
//                   marginTop: 14,
//                   fontSize: 32,
//                   fontFamily: 'montserrat bold',
//                   fontWeight: 'bold',
//                   color: '#48604C',

//                 }}
//                 odomStyle={{
//                   fontSize: 32,
//                   fontFamily: 'montserrat bold',
//                   fontWeight: 'bold',
//                   color: '#48604C',
//                   marginBottom: 4
//                   // padding: 0,
//                 }} />
//         </li>
//       </ul>
//     </div>
//   </div>
// );
